// 0.45.08 - "Line spacing" on Title and Markdown elements.
//
// Henaket's line heights are the default (value 0 or unset). The admin
// may move them in 4px steps, the grid Henaket's own line heights sit
// on. The element stores `line_spacing` in px: negative = tighter,
// positive = looser. It is applied as the --text-leading-step CSS
// variable, which the heading and markdown rules subtract from the
// Henaket value (with a floor of 1.1em so lines never overlap).

export const LINE_SPACING_OPTIONS = [
  { value: -8, label: 'Tighter by 8px' },
  { value: -4, label: 'Tighter by 4px' },
  { value: 0, label: 'Henaket (default)' },
  { value: 4, label: 'Looser by 4px' },
  { value: 8, label: 'Looser by 8px' },
];

// 0.45.44 - Titles also offer 12px either way (Markdown keeps the 4px
// and 8px steps).
export const TITLE_LINE_SPACING_OPTIONS = [
  { value: -12, label: 'Tighter by 12px' },
  ...LINE_SPACING_OPTIONS,
  { value: 12, label: 'Looser by 12px' },
];

const ALLOWED = new Set(TITLE_LINE_SPACING_OPTIONS.map((o) => o.value));

// The stored value, or 0 (Henaket) for anything unset or unknown.
export function lineSpacingOf(e) {
  const v = Number(e && e.line_spacing);
  return Number.isFinite(v) && ALLOWED.has(v) ? v : 0;
}

// Inline style entries for the element, empty at the Henaket default.
export function lineSpacingStyle(e) {
  const v = lineSpacingOf(e);
  return v ? { '--text-leading-step': `${-v}px` } : {};
}
